export const tranformFormula = (formula) => {
  const transformedFormula = formula.map((elem) => {
    const obj = {}
    if (elem.isData) {
      obj.search = elem.search
    } else {
      elem.children.sort((a, b) => a.position - b.position)
      const transformedFormulaAux = tranformFormula(elem.children)
      obj[elem.operator] = transformedFormulaAux
    }
    return obj
  })

  return transformedFormula
}

const transformDataArray = (transformedData, obj, operator, operators) => {
  const operatorArray = operators[0]
  const currentArray = transformedData[operator] || []
  if (operators.length === 1) {
    return obj[operator].map((elem, index) => ({
      ...currentArray[index],
      [operatorArray]: elem[operatorArray],
    }))
  } else if (operators.length > 1 && typeof operators[1] === 'number') {
    return obj[operator].map((elem, index) => {
      return {
        ...currentArray[index],
        [operatorArray]: transformDataArray(
          currentArray[index] || {},
          elem,
          operators[0],
          operators.slice(2)
        ),
      }
    })
  } else {
    return obj[operator].map((elem, index) => ({
      ...currentArray[index],
      [operatorArray]: transformDataRecursive(
        currentArray[index] || {},
        elem[operators[0]],
        operators[1],
        operators.slice(2)
      ),
    }))
  }
}
const isNumeric = (str) => !isNaN(Number(str))

const transformDataRecursive = (transformedData, obj, operator, operators) => {
  if (operators.length > 0) {
    if (isNumeric(operators[0])) {
      const arrayIndex = Number(operators[0])
      if (!transformedData[operator]) {
        transformedData[operator] = []
      }
      transformedData[operator][arrayIndex] = transformDataRecursive(
        transformedData[operator] ? transformedData[operator][arrayIndex] || {} : {},
        obj[operator] ? obj[operator][arrayIndex] || {} : {},
        operators[1],
        operators.slice(2)
      )
    } else {
      transformedData[operator] = transformDataRecursive(
        transformedData[operator] || {},
        obj[operator] || {},
        operators[0],
        operators.slice(1)
      )
    }
  } else if (obj[operator] !== undefined) {
    transformedData[operator] = obj[operator]
  }

  return transformedData
}

const transformCreatedVars = (checkedBox) => {
  const createdVars = checkedBox.filter((elem) => elem.created)
  const vars = {}
  createdVars.forEach((elem) => {
    vars[elem.label] = {
      label: elem.label,
      value: elem.value,
      description: elem?.description,
      show: elem.show,
      show_sitio: elem.show_sitio,
      global_variable: elem?.global_variable,
      created: elem.created,
    }
  })

  return vars
}

export const transformData = (data, checkedBox) => {
  const selectedVars = checkedBox.filter((elem) => !elem.created).map((elem) => elem.search)
  let transformedData = {}
  selectedVars.forEach((selectedVar) => {
    transformedData = transformDataRecursive(transformedData, data, selectedVar[0], selectedVar.slice(1))
    // console.log('transformDataRecursive2', transformDataRecursive2(data, selectedVar.slice(1)))
  })

  const createdVars = transformCreatedVars(checkedBox)
  if (Object.keys(createdVars).length) {
    transformedData['var'] = {
      ...transformedData['var'],
      ...createdVars,
    }
  }

  return transformedData
}
